import script from "./DisablePersonalNote.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisablePersonalNote.vue?vue&type=script&setup=true&lang=ts"

import "./DisablePersonalNote.vue?vue&type=style&index=0&id=a85612b2&lang=scss"

const __exports__ = script;

export default __exports__